import {combineReducers} from "redux";

const profileDetails = (state = {}, action) => {
    let header = state.header;

    switch(action.type){
        case "SUMMARY_DATA_LOADED":
            return{
                ...state,
                summaryData: action.data
            };
        default:
            return {
                ...state,
                header
            }
    }
};

export default combineReducers({
  profileDetails: profileDetails})



// WEBPACK FOOTER //
// ./src/reducers/index.js